import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseModule from '@/store/baseModule';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

const rejectionTypesModule = (store) => {
  store.registerModule(
    ['requests', 'rejectionTypes'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.P2C_BASE_URI}/rejection_types`,
        }),
        retry: { nbLeft: 3, timeout: 2000 },
      }),
      makeQueryParams: makeListRequest({}),
    })
  );
};

export default rejectionTypesModule;
